var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.89341 5.68746C9.65178 5.68746 9.45591 5.49158 9.45591 5.24996L9.45591 1.16663C9.45591 0.925001 9.65178 0.729126 9.89341 0.729126C10.135 0.729126 10.3309 0.925001 10.3309 1.16663L10.3309 5.24996C10.3309 5.49158 10.135 5.68746 9.89341 5.68746Z",
    fill: "#0D0D0D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.08398 7.29163C3.11749 7.29163 2.33398 6.50812 2.33398 5.54163C2.33398 4.57513 3.11749 3.79163 4.08398 3.79163C5.05048 3.79163 5.83398 4.57513 5.83398 5.54163C5.83398 6.50812 5.05048 7.29163 4.08398 7.29163Z",
    fill: "#0D0D0D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91732 6.70829C8.95082 6.70829 8.16732 7.49179 8.16732 8.45829C8.16732 9.42479 8.95082 10.2083 9.91732 10.2083C10.8838 10.2083 11.6673 9.42479 11.6673 8.45829C11.6673 7.49179 10.8838 6.70829 9.91732 6.70829Z",
    fill: "#0D0D0D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.62257 8.74996C3.62257 8.50833 3.81845 8.31246 4.06007 8.31246C4.3017 8.31246 4.49757 8.50833 4.49757 8.74996V12.8333C4.49757 13.0749 4.3017 13.2708 4.06007 13.2708C3.81845 13.2708 3.62257 13.0749 3.62257 12.8333V8.74996Z",
    fill: "#0D0D0D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89341 13.2708C9.65178 13.2708 9.45591 13.0749 9.45591 12.8333V11.6666C9.45591 11.425 9.65178 11.2291 9.89341 11.2291C10.135 11.2291 10.3309 11.425 10.3309 11.6666V12.8333C10.3309 13.0749 10.135 13.2708 9.89341 13.2708Z",
    fill: "#0D0D0D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.62257 1.16663C3.62257 0.925001 3.81845 0.729126 4.06007 0.729126C4.3017 0.729126 4.49757 0.925001 4.49757 1.16663V2.33329C4.49757 2.57492 4.3017 2.77079 4.06007 2.77079C3.81845 2.77079 3.62257 2.57492 3.62257 2.33329V1.16663Z",
    fill: "#0D0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/Sort.d447846e83f0631c95a8932d8008e346.svg";
export { ForwardRef as ReactComponent };